"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Lounge;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _index = require("../../assets/icons/index");
function Lounge(param) {
    var image = param.image, airport = param.airport, loungeName = param.loungeName, openingTimes = param.openingTimes, openDays = param.openDays;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_jsxruntime.Fragment, {
        children: [
            image && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Image, {
                src: image,
                alt: airport
            }),
            loungeName && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                color: "#000000",
                children: loungeName
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.SimpleGrid, {
                cols: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.MapPin, {
                                width: 24,
                                color: "#000000"
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                                style: {
                                    paddingLeft: "5px"
                                },
                                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                                    color: "#000000",
                                    style: {
                                        width: "130px",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden"
                                    },
                                    children: airport
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.Clock, {
                                color: "#000000",
                                width: 24
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                                style: {
                                    paddingLeft: "5px"
                                },
                                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                                    color: "#000000",
                                    style: {
                                        width: "130px",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden"
                                    },
                                    children: openingTimes
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
